export const DEFAULT_CONTENT = {
  id: "site",
  hero: {
    badge: "Vidyaranyapura, Bengaluru · Est. Local Print Workshop",
    title: "High-Impact Flex, Vinyl & LED Signage Printing in Bengaluru",
    sub: "Direct from our Vidyaranyapura workshop — same-day flex banners, premium backlit vinyl, 3D acrylic LED letters and sunboard displays. Trusted by local shops, events and offices.",
    stat1: "Same-Day Flex Printing",
    stat2: "2-Year LED Warranty",
    stat3: "Free Bengaluru Delivery",
    image_id: null,
  },
  services: [
    { id: "flex", name: "Flex Printing", desc: "High-resolution frontlit & star flex banners for shops, events and hoardings. Same-day output.", price: "from ₹12/sq.ft", image_id: null },
    { id: "vinyl", name: "Vinyl Printing", desc: "Self-adhesive stickers, glass branding, one-way vision and frosted film in matte or gloss.", price: "from ₹35/sq.ft", image_id: null },
    { id: "sunboard", name: "Sun Board", desc: "Rigid 3mm & 5mm PVC foam board displays — direct UV or vinyl mounted for standees & signage.", price: "from ₹45/sq.ft", image_id: null },
    { id: "led", name: "LED Name Boards", desc: "3D acrylic glowing letters & backlit signboards. Waterproof modules with 2-year warranty.", price: "from ₹120/inch", image_id: null },
  ],
  fixed_products: [
    { name: "Standard Frontlit Flex Banner", price: "₹12", unit: "per sq.ft · min 20 sq.ft", turn: "Same day (4 hrs)" },
    { name: "Star Flex High-Gloss Banner", price: "₹22", unit: "per sq.ft · heavy outdoor", turn: "Same day" },
    { name: "Self-Adhesive Vinyl Sticker", price: "₹35", unit: "per sq.ft · matte/gloss", turn: "24 hours" },
    { name: "Roll-up Standee 6×3 ft (with stand)", price: "₹1,250", unit: "per piece · with bag", turn: "Same day" },
  ],
  custom_products: [
    { name: "3D Acrylic LED Glowing Letters", price: "₹120 / inch depth", desc: "Custom font cut, waterproof LED modules, 2-year warranty." },
    { name: "Sun Board Display (3mm & 5mm)", price: "₹45 / sq.ft", desc: "Direct UV or vinyl mounted on rigid PVC foam board." },
    { name: "Backlit Flex Signboard with Frame", price: "₹85 / sq.ft", desc: "Heavy MS tubular frame with internal LED illumination." },
    { name: "Storefront Glass & Wall Branding", price: "₹50 / sq.ft", desc: "One-way vision, frosted film or solid opaque vinyl." },
  ],
  contact: {
    phone: "+916363032874",
    phoneDisplay: "+91 63630 32874",
    whatsapp: "916363032874",
    email: "orders@creativeprints.in",
    address: "108, Bloomfield Garden, Ramachandrapura Main Rd, Chamundeswari Layout, Vidyaranyapura, Bengaluru, Karnataka 560097",
    hours: "Mon – Sat: 9:00 AM – 9:00 PM · Sun: 10:00 AM – 4:00 PM",
  },
};
